var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PresignedUrl from '../../services/api/presignedUrl';
import AudioPlayer from 'react-h5-audio-player';
const QuestionAnswerAudio = ({ question }) => {
    const { t } = useTranslation();
    const [audio, setAudio] = useState({});
    const userAnswer = JSON.parse(question.questionAnswer.rawAnswer || '{}');
    const loadAudio = (question) => __awaiter(void 0, void 0, void 0, function* () {
        const bucketExamsAudioRecord = process.env.REACT_APP_SUMADI_BUCKET_EXAMS_AUDIO || 'sumadi-exams-audio-records-dev';
        const rawAnswer = JSON.parse(question.questionAnswer.rawAnswer || '{}');
        const audioUrl = yield PresignedUrl('getObject', bucketExamsAudioRecord, rawAnswer.userAnswer);
        setAudio(audioUrl);
    });
    useEffect(() => {
        loadAudio(question);
    }, []);
    const audioOnLoadMetadata = (questionId) => {
        const audioRef = document.getElementById(`${questionId}`);
        if (audioRef.duration === Infinity) {
            audioRef.currentTime = Number.MAX_SAFE_INTEGER;
            audioRef.ontimeupdate = () => {
                audioRef.ontimeupdate = null;
                audioRef.currentTime = 0.001;
            };
        }
    };
    return (_jsxs(_Fragment, { children: [(userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.length) > 0 && !audio.presignedResponse &&
                _jsxs("h6", { children: [t('GENERAL.LOADING'), "..."] }, void 0), userAnswer && audio.presignedResponse &&
                _jsx("div", Object.assign({ className: "audio-player-list" }, { children: _jsx("div", Object.assign({ className: "audio-player-list-item" }, { children: _jsx("div", Object.assign({ className: "sumadi-audio-player" }, { children: _jsx("div", Object.assign({ role: "group", tabIndex: 0, "aria-label": "Audio Player", className: "rhap_container" }, { children: _jsx(AudioPlayer, { src: audio.presignedResponse, preload: "metadata" }, void 0) }), void 0) }), void 0) }), void 0) }), void 0)] }, void 0));
};
export default QuestionAnswerAudio;
